"use client";

import * as React from "react";
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail } from "lucide-react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="30157" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 bg-muted animate-pulse rounded" data-index={i} />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <nav className="flex flex-col gap-3">
        <Link to="/HomePage" className="text-slate-400 hover:text-[hsl(188,53%,39%)] transition-colors text-sm">Inicio</Link>
        <Link to="/ServicesPage" className="text-slate-400 hover:text-[hsl(188,53%,39%)] transition-colors text-sm">Servicios</Link>
        <Link to="/ContactPage" className="text-slate-400 hover:text-[hsl(188,53%,39%)] transition-colors text-sm">Contacto</Link>
        <Link to="#" className="text-slate-400 hover:text-[hsl(188,53%,39%)] transition-colors text-sm">Preguntas Frecuentes</Link>
      </nav>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-slate-400 hover:text-[hsl(188,53%,39%)] transition-colors text-sm" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function PieDePagina() {
  const currentYear = new Date().getFullYear();
  return <section id="pie-de-página-integral" className="border-t border-slate-900 pt-16 pb-8 dark !bg-[hsl(215,25%,27%)]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577195/img/image_2k6dwy9p.png" alt="NexoMayor Logo" className="h-28 w-auto object-contain brightness-0 invert !text-[hsl(175,84%,32%)]" />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              NexoMayor es su aliado estratégico en la gestión integral para personas mayores. Actuamos como senior-care planners coordinando salud, bienestar y logística con total transparencia y reportes para la familia.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-semibold text-slate-100"><br />Navegación</h3>
            <MenuProvider menu_id="17" className="w-full">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-semibold text-slate-100"><br />Atención Directa</h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3 text-sm text-slate-400">
                <MapPin className="w-5 h-5 text-[hsl(188,53%,39%)] shrink-0 mt-0.5" />
                <span>Santiago, Región Metropolitana, Chile</span>
              </div>
              <Link to="https://wa.me/56934141843?text=Hola%20NexoMayor,%20quiero%20agendar%20una%20evaluación%20para%20coordinar%20el%20cuidado%20de%20un%20familiar." className="flex items-center gap-3 text-sm text-slate-400 hover:text-[hsl(188,53%,39%)] transition-colors group">
                <Phone className="w-5 h-5 text-[hsl(188,53%,39%)] shrink-0 group-hover:scale-110 transition-transform" />
                <span>+56 9 3414 1843</span>
              </Link>
              <Link to="mailto:contacto@nexomayor.cl" className="flex items-center gap-3 text-sm text-slate-400 hover:text-[hsl(188,53%,39%)] transition-colors group">
                <Mail className="w-5 h-5 text-[hsl(188,53%,39%)] shrink-0 group-hover:scale-110 transition-transform" />
                <span>contacto@nexomayor.cl</span>
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-semibold text-slate-100"><br />Confianza</h3>
            <p className="text-slate-400 text-sm mb-2">
              Protocolos de seguridad, trazabilidad y reportes constantes para su total tranquilidad.
            </p>
            <div className="flex gap-3">
              {[{
              icon: Facebook,
              label: "Facebook",
              href: "https://www.facebook.com/NexoMayor.Chile/"
            }, {
              icon: Instagram,
              label: "Instagram",
              href: "https://www.instagram.com/nexo_mayor"
            }, {
              icon: Twitter,
              label: "Twitter",
              href: "#"
            }].map((social, i) => <Link key={i} to={social.href} className="flex items-center justify-center w-10 h-10 rounded-lg border border-slate-800 text-slate-400 hover:bg-[hsl(188,53%,39%)] hover:text-white hover:border-[hsl(188,53%,39%)] transition-all duration-300" aria-label={social.label} data-index={i}>
                  <social.icon className="w-5 h-5" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="mb-8 bg-slate-900" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
          <p>&copy; {currentYear} NexoMayor. Todos los derechos reservados.</p>
          <div className="flex gap-6">
            <Link to="/ContactPage" className="hover:text-[hsl(188,53%,39%)] transition-colors">
              Política de Privacidad
            </Link>
            <Link to="/ContactPage" className="hover:text-[hsl(188,53%,39%)] transition-colors">
              Términos de Servicio
            </Link>
          </div>
        </div>
      </div>
    </section>;
}